<template>
<div id="app" v-if="loaded">
	<van-nav-bar
		v-if="$nav.show"
		:title="$nav.title"
		left-text=""
		right-text=""
		left-arrow
		@click-left="event_navleft"
		style="background-color:#0085e4;color:#FFFFFF;"
	/>
	<footer v-if="$route.meta.showNav">
		<li v-bind:class="{active:$route.name == 'Index'}"><router-link to="/"><i class="iconfont icon-test"></i><span>考试</span></router-link></li>
		<li v-bind:class="{active:$route.name == 'Video'}"><router-link to="/video"><i class="iconfont icon-zhengce"></i><span>考场视频</span></router-link></li>
		<li v-bind:class="{active:$route.name == 'News'}" style="display:none"><router-link to="/news"><i class="iconfont icon-tubiao-"></i><span>招生海报</span></router-link></li>
		<li v-bind:class="{active:$route.name == 'Mine'}"><router-link to="/mine"><i class="iconfont icon-user"></i><span>我的</span></router-link></li>
	</footer>
	<keep-alive>
		<router-view v-if="$route.meta.keepAlive"></router-view>
	</keep-alive>
	<router-view v-if="!$route.meta.keepAlive"></router-view>
	<audio poster="" name="" author="" id="audio" autoplay="true">
		<source src="http://jk.ioccn.com/k.mp3">
	</audio>
</div>
</template>

<script>
export default {
	name: 'App',
	data(){
		return {
			loaded:false,
			title:''
		}
	},
	beforeRouteEnter (to, from, next) {
		console.log(to)
		next(vm => {})
	},
	components: {},
	mounted () {},
	methods:{
		event_navleft(){
			this.$app.goBack();
		}
	},
	created () {
		var u = navigator.userAgent;
		var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
		this.$store.state.config.starturl = window.location.href
		this.$store.state.config.jtype = isiOS ? true : false
		this.$query = this.$route.query
		//开发工具中非DEBUG时需要打开这个
		if(this.$query.token){
			//this.$store.state.token = this.$query.token;
			//this.$cookies.set('token111111',this.$store.state.token);
		}
		if(this.$debug.debuging){
			if(this.$query.token){
				this.$store.state.token = this.$query.token;
				this.$cookies.set('token111111',this.$store.state.token);
			}
		}else{
			if(this.$query.token && this.$query.token == decodeURI(this.$cookies.get('token111111'))){
				this.$store.state.token = this.$query.token;
			}
		}
		if(!this.$query.token || this.$query.token != decodeURI(this.$cookies.get('token111111'))){
			var that = this;
			var query = [];
			for(var n in this.$query){
				if(n == 'token'){
					continue;
				}
				query.push(n+'='+this.$query[n]);
			}
			if(this.$debug.debuging){
				window.location.href = that.$store.state.config.domain+'mobile/index/indexautologin.html?callback='+encodeURIComponent(that.$store.state.config.webdomain+that.$route.path+'?'+query.join('&'));
			}else{
				window.location.href = that.$store.state.config.domain+'mobile/index/authusertest.html?callback='+encodeURIComponent(that.$store.state.config.webdomain+that.$route.path+'?'+query.join('&'));
			}
		}

		if(this.$store.state.userInfo.unid == null && this.$query.token){
			//获取用户信息
			this.$https.post('/api/user/info.html',this.$qs.stringify({
				token:this.$store.state.token
			})).then((res) => {
				res.data.data.unid = res.data.data.id;
				this.$store.state.userInfo = res.data.data;
				console.log("==========================>userinfo:");
				console.log(this.$store.state.userInfo);
				//localStorage.setItem('token', this.$query.token);
				console.log('当前场景值：'+this.$query.scene)
				if(this.$query.scene){
					console.log('处理场景信息')
					this.$https.post('/api/distribution/relation.html',this.$qs.stringify({
						token:this.$store.state.token,
						scene:this.$query.scene
					})).then((res) => {
						this.$app.reloadUser()
					});
				}
				this.$app.pr('/api/common/jsparams',{
					url:window.location.href
				}).then((res) => {
					wx.config(res.data.shareparam);
					try{
						wx.ready(function(){
							wx.onMenuShareAppMessage({
								title:res.data.share_name,
								desc:res.data.share_desc,
								link:'https://jk.ioccn.com/',
								imgUrl:res.data.share_image,
								success:function(){
								}
							});
							wx.onMenuShareTimeline({
								title: res.data.share_name,
								link: 'https://jk.ioccn.com/',
								imgUrl: res.data.share_image
							});
						});
					}catch(e){alert('fx error'+e)}
				});
			},(res) => {
				console.log(res)
			})
		}
		
		if(this.$store.state.config.data == null){
			//获取配置信息
			this.$https.post('/api/common/getconfig.html',this.$qs.stringify({
				token:this.$store.state.token
			})).then((res) => {
				this.$store.state.config.data = res.data.data;
				this.loaded = true
			},(res) => {
				console.log(res)
			})
		}

		if(this.$query.bg_user_id){
			this.$router.push('/signup?bg_user_id='+this.$query.bg_user_id)
		}

		//预处理audio问题
		/*let hand = setInterval(function(){
			if($('audio').length){
				try{
					$('audio')[0].play()
					document.addEventListener("WeixinJSBridgeReady", function () {
						$('audio')[0].play()
					});
				}catch(e){
					alert('yy error'+e)
				}
				clearInterval(hand)
			}
		},100);*/

	}
}
</script>
<style scoped>
	footer li{
		line-height:20px;
	}
	audio{
		width:0px;
		height:0px;
	}
</style>



// WEBPACK FOOTER //
// src/App.vue